w2p.controller('EmailtemplatessCtrl', function($scope,$http) {
    $("#et_select_lang").on("change", function(obj) {
       window.location = '?lang='+this.value;
    });

});